import * as Swiper from 'swiper';

import { NgZone, SimpleChanges, KeyValueDiffers } from '@angular/core';
import { Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Directive, Optional, OnInit, DoCheck, OnDestroy, OnChanges } from '@angular/core';

import { SwiperConfig, SwiperConfigInterface, SwiperEvents } from './swiper.interfaces';


export class SwiperDirective implements OnInit, DoCheck, OnDestroy, OnChanges {
  public swiper: any;

  private configDiff: any;

   disabled: boolean = false;

   runInsideAngular: boolean = false;

   config: SwiperConfigInterface;

   s_init                = new EventEmitter<any>();
   s_slideChangeStart    = new EventEmitter<any>();
   s_slideChangeEnd      = new EventEmitter<any>();
   s_slideNextStart      = new EventEmitter<any>();
   s_slideNextEnd        = new EventEmitter<any>();
   s_slidePrevStart      = new EventEmitter<any>();
   s_slidePrevEnd        = new EventEmitter<any>();
   s_transitionStart     = new EventEmitter<any>();
   s_transitionEnd       = new EventEmitter<any>();
   s_touchStart          = new EventEmitter<any>();
   s_touchMove           = new EventEmitter<any>();
   s_touchMoveOpposite   = new EventEmitter<any>();
   s_sliderMove          = new EventEmitter<any>();
   s_touchEnd            = new EventEmitter<any>();
   s_click               = new EventEmitter<any>();
   s_tap                 = new EventEmitter<any>();
   s_doubleTap           = new EventEmitter<any>();
   s_imagesReady         = new EventEmitter<any>();
   s_progress            = new EventEmitter<any>();
   s_reachBeginning      = new EventEmitter<any>();
   s_reachEnd            = new EventEmitter<any>();
   s_destroy             = new EventEmitter<any>();
   s_setTranslate        = new EventEmitter<any>();
   s_setTransition       = new EventEmitter<any>();
   s_autoplay            = new EventEmitter<any>();
   s_autoplayStart       = new EventEmitter<any>();
   s_autoplayStop        = new EventEmitter<any>();
   s_lazyImageLoad       = new EventEmitter<any>();
   s_lazyImageReady      = new EventEmitter<any>();
   s_paginationRendered  = new EventEmitter<any>();
   s_scroll              = new EventEmitter<any>();

  constructor(private zone: NgZone, private elementRef: ElementRef, private differs : KeyValueDiffers,
     private defaults: SwiperConfig) {}

  ngOnInit() {
    let element = this.elementRef.nativeElement;
    let options = new SwiperConfig(this.defaults);

    options.assign(this.config); // Custom config

    if (this.runInsideAngular) {
      this.swiper = new Swiper(element, options);
    } else {
      this.zone.runOutsideAngular(() => {
        this.swiper = new Swiper(element, options);
      });
    }

    // Add native swiper event handling
    SwiperEvents.forEach((eventName) => {
      let self = this;

      this.swiper.on(eventName, function(event) {
        self[`s_${eventName}`].emit(event);
      });
    });

    if (!this.configDiff) {
      this.configDiff = this.differs.find(this.config || {}).create(null);
    }
  }

  ngDoCheck() {
    let changes = this.configDiff.diff(this.config || {});

    if (changes) {
      this.ngOnDestroy();

      // This is needed for the styles to update properly
      setTimeout(() => {
        this.ngOnInit();

        this.update();
      }, 0);
    }
  }

  ngOnDestroy() {
    if (this.swiper) {
      if (this.runInsideAngular) {
        this.swiper.destroy(true, true);
      } else {
        this.zone.runOutsideAngular(() => {
          this.swiper.destroy(true, true);
        });
      }

      this.swiper = null;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.swiper && changes['disabled']) {
      if (changes['disabled'].currentValue != changes['disabled'].previousValue) {
        if (changes['disabled'].currentValue === true) {
          this.swiper.lockSwipes();
        } else if (changes['disabled'].currentValue === false) {
          this.swiper.unlockSwipes();
        }
      }
    }
  }

  update(updateTranslate?: boolean) {
    setTimeout(() => {
      if (this.swiper) {
        if (this.runInsideAngular) {
          this.swiper.update(updateTranslate);
        } else {
          this.zone.runOutsideAngular(() => {
            this.swiper.update(updateTranslate);
          });
        }
      }
    }, 0);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[swiper]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: KeyValueDiffers, },
{type: SwiperConfig, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'disabled': [{ type: Input },],
'runInsideAngular': [{ type: Input },],
'config': [{ type: Input, args: ['swiper', ] },],
's_init': [{ type: Output, args: ['init', ] },],
's_slideChangeStart': [{ type: Output, args: ['slideChangeStart', ] },],
's_slideChangeEnd': [{ type: Output, args: ['slideChangeEnd', ] },],
's_slideNextStart': [{ type: Output, args: ['slideNextStart', ] },],
's_slideNextEnd': [{ type: Output, args: ['slideNextEnd', ] },],
's_slidePrevStart': [{ type: Output, args: ['slidePrevStart', ] },],
's_slidePrevEnd': [{ type: Output, args: ['slidePrevEnd', ] },],
's_transitionStart': [{ type: Output, args: ['transitionStart', ] },],
's_transitionEnd': [{ type: Output, args: ['transitionEnd', ] },],
's_touchStart': [{ type: Output, args: ['touchStart', ] },],
's_touchMove': [{ type: Output, args: ['touchMove', ] },],
's_touchMoveOpposite': [{ type: Output, args: ['touchMoveOpposite', ] },],
's_sliderMove': [{ type: Output, args: ['sliderMove', ] },],
's_touchEnd': [{ type: Output, args: ['touchEnd', ] },],
's_click': [{ type: Output, args: ['click', ] },],
's_tap': [{ type: Output, args: ['tap', ] },],
's_doubleTap': [{ type: Output, args: ['doubleTap', ] },],
's_imagesReady': [{ type: Output, args: ['imagesReady', ] },],
's_progress': [{ type: Output, args: ['progress', ] },],
's_reachBeginning': [{ type: Output, args: ['reachBeginning', ] },],
's_reachEnd': [{ type: Output, args: ['reachEnd', ] },],
's_destroy': [{ type: Output, args: ['destroy', ] },],
's_setTranslate': [{ type: Output, args: ['setTranslate', ] },],
's_setTransition': [{ type: Output, args: ['setTransition', ] },],
's_autoplay': [{ type: Output, args: ['autoplay', ] },],
's_autoplayStart': [{ type: Output, args: ['autoplayStart', ] },],
's_autoplayStop': [{ type: Output, args: ['autoplayStop', ] },],
's_lazyImageLoad': [{ type: Output, args: ['lazyImageLoad', ] },],
's_lazyImageReady': [{ type: Output, args: ['lazyImageReady', ] },],
's_paginationRendered': [{ type: Output, args: ['paginationRendered', ] },],
's_scroll': [{ type: Output, args: ['scroll', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
